// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const semenPaths = {
    list:   ()    => 'admin/semen',
    detail: (id)  => `admin/semen/${id}`,
};
